import { useContext } from 'react';
import { FormTokenChainContext } from '../../context/FormTokenChainContext';

// Like useFormTokenChainContext but returns null when no provider is mounted
// (Sidebar renders on the top-level error/loading PageLayout, outside LoggedInLayout).
export const useFormTokenChainContextOptional = () => {
  const context = useContext(FormTokenChainContext);
  return context.isProvided ? context : null;
};
